import type { SVGAttributes } from 'react';

export function BeneficiariesIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props} viewBox="0 0 32 32">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="m11.172 16 3.213 3.227 6.44-6.454"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M14.332 3.267c.92-.787 2.427-.787 3.36 0l2.107 1.813c.4.347 1.146.627 1.68.627h2.266a2.583 2.583 0 0 1 2.573 2.573v2.267c0 .52.28 1.28.627 1.68l1.814 2.106c.786.92.786 2.427 0 3.36L26.945 19.8c-.346.4-.626 1.147-.626 1.68v2.267a2.583 2.583 0 0 1-2.574 2.573h-2.267c-.52 0-1.28.28-1.68.627l-2.106 1.813c-.92.787-2.427.787-3.36 0l-2.107-1.813c-.4-.347-1.146-.627-1.68-.627H8.24a2.583 2.583 0 0 1-2.574-2.573v-2.28c0-.52-.28-1.267-.613-1.667l-1.8-2.12c-.773-.92-.773-2.413 0-3.333l1.8-2.12c.333-.4.613-1.147.613-1.667V8.267A2.583 2.583 0 0 1 8.24 5.693h2.306c.52 0 1.28-.28 1.68-.626z"
			/>
		</svg>
	);
}
